document.addEventListener("DOMContentLoaded", function () {
  const REQUIRED_PAIRS = 2;

  function getCartMissionElements() {
    return {
      box: document.querySelector(".qris-cart-mission"),
      fill: document.querySelector(".qris-progress-fill"),
      message: document.querySelector(".qris-cart-message"),
      title: document.querySelector(".qris-cart-title")
    };
  }

  function updateMission(cart) {
    const itemsCount = cart.item_count || 0;
    const progress = Math.min((itemsCount / REQUIRED_PAIRS) * 100, 100);
    const remaining = Math.max(REQUIRED_PAIRS - itemsCount, 0);

    const el = getCartMissionElements();
    if (!el.box || !el.fill || !el.message || !el.title) return;

    el.fill.style.width = progress + "%";

    if (itemsCount >= REQUIRED_PAIRS) {
      el.box.classList.add("qris-unlocked");
      el.title.innerHTML = "🎉 ¡Beneficios desbloqueados!";
      el.message.innerHTML = "Ya tienes <strong>envío GRATIS</strong> + <strong>líquido multipropósito GRATIS</strong>.";
    } else {
      el.box.classList.remove("qris-unlocked");
      el.title.innerHTML = "🎁 Desbloquea tus beneficios";
      el.message.innerHTML = `✨ Solo agrega <strong>${remaining} par más</strong> para obtener ambos beneficios.`;
    }
  }

  function fetchCartAndUpdate() {
    fetch("/cart.js")
      .then(response => response.json())
      .then(cart => updateMission(cart))
      .catch(error => console.warn("Qristalino cart mission error:", error));
  }

  fetchCartAndUpdate();

  document.body.addEventListener("click", function () {
    setTimeout(fetchCartAndUpdate, 700);
  });

  document.body.addEventListener("change", function () {
    setTimeout(fetchCartAndUpdate, 700);
  });
});